@if (title()) {
<strong class="d-block">{{ title() }}</strong>
}
{{ text() }}
